import type { ComponentProps } from "react";

export default function UsersIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.9999 13.1974C16.2131 13.8069 17.2533 14.785 18.0126 16.008C18.1629 16.2502 18.2381 16.3713 18.2641 16.539C18.3169 16.8798 18.0839 17.2988 17.7665 17.4336C17.6103 17.5 17.4346 17.5 17.0832 17.5M13.3332 9.6102C14.568 8.99657 15.4165 7.72238 15.4165 6.25C15.4165 4.77762 14.568 3.50343 13.3332 2.8898M11.6665 6.25C11.6665 8.32107 9.9876 10 7.91653 10C5.84546 10 4.16653 8.32107 4.16653 6.25C4.16653 4.17893 5.84546 2.5 7.91653 2.5C9.9876 2.5 11.6665 4.17893 11.6665 6.25ZM2.13256 15.782C3.46115 13.7871 5.55767 12.5 7.91653 12.5C10.2754 12.5 12.3719 13.7871 13.7005 15.782C13.9916 16.219 14.1371 16.4375 14.1203 16.7166C14.1073 16.9339 13.9648 17.2 13.7912 17.3313C13.5681 17.5 13.2614 17.5 12.6479 17.5H3.18516C2.57167 17.5 2.26493 17.5 2.0419 17.3313C1.86824 17.2 1.72577 16.9339 1.71273 16.7166C1.69597 16.4375 1.8415 16.219 2.13256 15.782Z"
        stroke="rgba(13,48,80,0.8)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
